import { Col, Image, Row, Typography } from "antd";

const CatCards = () => {
  return (
    <Row className="max-sm:p-0 bg-[#f5f5f5]">
      <Col span={12} sm={8} className="px-8 py-16 max-lg:px-4 max-lg:py-8">
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/automotive.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            Automotive
          </Typography.Title>
        </Row>
      </Col>
      <Col span={12} sm={8} className="px-8 py-16 max-lg:px-4 max-lg:py-8">
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/sports.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            Sports, Leisure & Flooring
          </Typography.Title>
        </Row>
      </Col>
      <Col span={12} sm={8} className="px-8 py-16 max-lg:px-4 max-lg:py-8">
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/ac.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            AC & Refrigeration
          </Typography.Title>
        </Row>
      </Col>
      <Col
        span={12}
        sm={8}
        className="px-8 py-16 max-lg:px-4 max-lg:py-8 sm:bg-[#007FC5]"
      >
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/buy-again.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            Buy Again
          </Typography.Title>
        </Row>
      </Col>
      <Col
        span={12}
        sm={8}
        className="px-8 py-16 max-lg:px-4 max-lg:py-8 bg-[#007FC5]"
      >
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/wishlist.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            Wishlist
          </Typography.Title>
        </Row>
      </Col>
      <Col
        span={12}
        sm={8}
        className="px-8 py-16 max-lg:px-4 max-lg:py-8 bg-[#007FC5]"
      >
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/new-product.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            New Products
          </Typography.Title>
        </Row>
      </Col>
      <Col span={0} sm={4}></Col>
      <Col span={12} sm={8} className="px-8 py-16 max-lg:px-4 max-lg:py-8">
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/top-selling.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            Top Selling
          </Typography.Title>
        </Row>
      </Col>
      <Col span={12} sm={8} className="px-8 py-16 max-lg:px-4 max-lg:py-8">
        <Row className="rounded-2xl overflow-hidden bg-white">
          <Image src="/assets/categories/clearance.jpg" preview={false} />
          <Typography.Title
            level={3}
            className="text-center w-full my-2 font-semibold text-12 max-sm:text-[3.5vw] max-lg:text-[2vw]"
          >
            Clearance Deals
          </Typography.Title>
        </Row>
      </Col>
      <Col span={0} sm={4}></Col>
    </Row>
  );
};
export default CatCards;
